import React from 'react';

export default function Fatal() {
  return <h2>Le Site de Pneu FRB inc. n'est pas disponible pour le moment</h2>;
}